/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { getRuntimeConfig } from "@/config/runtimeConfig";
import {
	PKCE_STATE_KEY,
	PKCE_VERIFIER_KEY,
	deriveCodeChallenge,
	generateCodeVerifier,
	generateState,
} from "@/modules/auth/core/pkce";

const DEFAULT_TARGET = "/newui";
// Só path absoluto, sem esquema/host embutido — "target" vem de query string
// pública (rota fora do gate de currentAuth) e é concatenado direto em
// `${backendOrigin}${target}`. Sem essa validação, algo como
// "?target=@evil.com" ou "?target=.evil.com/x" muda o host da URL montada
// (open redirect) — quem tiver acesso ao code_challenge/state entregues de
// brinde no processo poderia montar phishing a partir de um domínio real.
const SAFE_TARGET_PATTERN = /^\/[A-Za-z0-9\-._~/]*$/;

export function SsoStart() {
	const [searchParams] = useSearchParams();
	const [error, setError] = useState<string | null>(null);
	// StrictMode roda o efeito duas vezes em dev — sem essa guarda, cada
	// invocação geraria seu próprio verifier/state e dispararia outro
	// redirect, deixando o sessionStorage e a navegação em corrida.
	const startedRef = useRef(false);

	useEffect(() => {
		if (startedRef.current) {
			return;
		}
		startedRef.current = true;

		async function start() {
			try {
				const verifier = generateCodeVerifier();
				const state = generateState();
				const challenge = await deriveCodeChallenge(verifier);

				sessionStorage.setItem(PKCE_VERIFIER_KEY, verifier);
				sessionStorage.setItem(PKCE_STATE_KEY, state);

				const { backendOrigin } = getRuntimeConfig();
				const requestedTarget = searchParams.get("target");
				const target =
					requestedTarget && SAFE_TARGET_PATTERN.test(requestedTarget) ? requestedTarget : DEFAULT_TARGET;
				const query = new URLSearchParams({ state, code_challenge: challenge });

				// target (ex.: /centrocirurgico, /newui) é rota de routes/web.php,
				// não de routes/api.php — não leva o prefixo /api.
				window.location.href = `${backendOrigin}${target}?${query.toString()}`;
			} catch (err) {
				console.error(err);
				setError("Não foi possível iniciar o login. Tente novamente.");
			}
		}

		start();
	}, []);

	return (
		<div id="splash-screen" className="splash-screen">
			<span className="mt-3">{error ?? "Redirecionando..."}</span>
		</div>
	);
}
